import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ExportType, IStandardColumns } from "./dynamicReports.service";
import { IColumnHeader } from "../models/IColumnHeader";
import { IReportDefinition } from "../models/IReportDefinition";
import { lastValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DynamicReportsService {
    constructor(
        private readonly http: HttpClient) {
    }

    getStandardColumns(): Promise<IStandardColumns> {
        return this.getColumnHeaders().then((columns) => {
            const reportColumns = columns;

            return {
                rowTitleColumn: this.findColumn("RowTitle", "SharedReport", reportColumns),
                stringColumn: this.findColumn("String", "SharedReport", reportColumns),
                doubleColumn: this.findColumn("Double", "SharedReport", reportColumns),
                dateColumn: this.findColumn("Date", "SharedReport", reportColumns),
                durationColumn: this.findColumn("Duration", "SharedReport", reportColumns)
            }
        });
    }

    getColumnHeaders(): Promise<IColumnHeader[]> {
        return lastValueFrom(this.http.get<IColumnHeader[]>(`/api/reports/columnheaders`))
            .then((columnHeaders) => {

                columnHeaders.forEach(column => {
                    column.uniqueId = this.getUniqueColumnId(column);
                });

                return columnHeaders;
            });
    }

    getUniqueColumnId(column: IColumnHeader): string {
        return `${column.ReportType}.${column.DataSourceValue}`;
    }


    findColumn(dataSource: string, dataSourceType: string, columns: IColumnHeader[]): IColumnHeader {
        dataSource = dataSource.toLowerCase();

        let foundColumn: IColumnHeader;

        const columnsToSearch = this.findColumnsOfType(dataSourceType, columns);

        columnsToSearch.forEach(header => {
            if (header.DataSourceValue.toLowerCase() === dataSource || header.Title.toLowerCase() == dataSource) {
                foundColumn = header;
            }
        });

        return Object.assign({}, foundColumn);
    }

    findColumnsOfType(dataSourceType: string, columns: IColumnHeader[]): IColumnHeader[] {
        dataSourceType = dataSourceType.toLowerCase();

        let columnsToSearch = [];

        if (dataSourceType && columns) {
            columnsToSearch = columns.filter(column => { return column.DataSourceType.toLowerCase().indexOf(dataSourceType) !== -1 });
        }

        return columnsToSearch;
    }

    generate(report: IReportDefinition, exportType: ExportType): Promise<void> {
        if (report == null) {
            return Promise.resolve();
        }

        return lastValueFrom(this.http.post(`/api/analytical/generate/${exportType}`, report, {responseType: 'blob' as 'json'}))
            .then((result: Blob) => {
                const fileURL = URL.createObjectURL(result);

                const a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = `${report.Title}${this.getDocumentExtension(exportType)}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
    }

    private getDocumentExtension(exportType: ExportType): string {
        switch (exportType) {
            case ExportType.PDF:
                return ".pdf";

            case ExportType.CSV:
                return ".csv";

            case ExportType.Excel:
                return ".xlsx";

            default:
                return "";
        }
    }
}
